import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

interface SuccessSnackbarProps {
  open: boolean;
  message: string;
  onClose: (event?: React.SyntheticEvent | Event, reason?: string) => void;
  autoHideDuration?: number;
}

const SuccessSnackbar: React.FC<SuccessSnackbarProps> = ({
  open,
  message,
  onClose,
  autoHideDuration = 4000, // Padrão de 4 segundos
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} // Posição
    >
      {/* Usar severity="success" e variant="filled" para destaque */}
      <Alert 
        onClose={onClose} // Permite fechar clicando no X
        severity="success" 
        variant="filled"
        sx={{ width: '100%', fontSize: '0.875rem' }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default SuccessSnackbar; 